<script setup>
import { PrimaryButton } from '@thunderbirdops/services-ui';
import { computed, ref, useTemplateRef } from 'vue';
import CancelForm from '@kc/vue/components/CancelForm.vue';

const formAction = window._page.currentView?.formAction;
const showForm = computed(() => window._page.appInitiatedAction !== 'false');
const verifyEmailInstruction = window._page.currentView?.verifyEmailInstruction;
const submitText = window._page.currentView?.submitText;

const verifyEmailForm = useTemplateRef('verify-email-form');
const cancelForm = useTemplateRef('cancel-form');
// @submit and @keyup.enter can both fire for one Enter keypress; keep the POST single-shot (#1231).
const isSubmitting = ref(false);

const onSubmit = () => {
  if (isSubmitting.value) return;
  if (!verifyEmailForm.value?.checkValidity()) return;
  isSubmitting.value = true;
  verifyEmailForm.value.submit();
};

const onCancel = () => {
  cancelForm?.value?.cancel();
};
</script>

<script>
export default {
  name: 'VerifyEmailView'
};
</script>

<template>
  <h2>{{ $t('emailVerifyTitle') }}</h2>
  <cancel-form ref="cancel-form" :action="formAction" cancelId="cancelBtn" cancelValue="true"
                cancelName="cancel-aia"/>
  <form id="kc-verify-email-form" ref="verify-email-form" method="POST" :action="formAction"
        @submit.prevent="onSubmit" @keyup.enter="onSubmit" v-if="showForm">
    <p>{{ verifyEmailInstruction }}</p>
    <div class="buttons">
      <primary-button data-testid="submit-btn" id="submit" class="submit" @click="onSubmit" :value="submitText"
                      :disabled="isSubmitting">{{
          submitText
        }}
      </primary-button>
      <primary-button variant="outline" data-testid="cancel-btn" id="cancel" class="submit" @click="onCancel">{{ $t('doCancel') }}</primary-button>
    </div>
  </form>
  <template v-else>
    <a :href="formAction" data-testid="action-url">{{ $t('doClickHere') }}</a>
    {{ $t('emailVerifyInstruction3') }}
  </template>
</template>

<style scoped>
.buttons {
  margin-top: var(--space-24);
  width: 100%;
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;

}
</style>
